/**
 * @author Eric Otto
 */

module.exports = {
    init: function ($container) {
        'use strict';

        const list = $container
            ? $container.querySelector('#eow-team-list')
            : document.querySelector('#eow-team-list');

        if (!list) {
            return;
        }

        const teamLinks = list.getElementsByClassName('eow-team-link');
        const closeLinks = list.getElementsByClassName('eow-close-link');

        for (let i = 0; i < teamLinks.length; i++) {
            teamLinks[i].addEventListener('click', function (event) {
                event.preventDefault();
                const overlay = teamLinks[i].parentNode.querySelector('.overlay');
                overlay.classList.add('open');
                ga('send', 'event', 'TeamLinks', 'click', overlay.getAttribute('data-name'));
            });
        }

        for (let i = 0; i < closeLinks.length; i++) {
            closeLinks[i].addEventListener('click', function (event) {
                event.preventDefault();
                closeLinks[i].parentNode.parentNode.parentNode.classList.remove('open');
            });
        }
    }
};
